import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfa1',
  templateUrl: './mfa1.component.html',
  styleUrls: ['./mfa1.component.scss']
})
export class Mfa1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
